import type { FC } from 'react'
import { Link } from 'react-router'
import { GridCellParams } from '@mui/x-data-grid'
import type { WorkUnitGridRow } from './WorkUnitTable'
import { Box, IconButton, Tooltip } from '@mui/material'
import Edit from '@mui/icons-material/Edit'
import Face from '@mui/icons-material/Face'

import elationSVG from '~/assets/images/elationSVG.svg'

interface WorklistLinksProps extends GridCellParams<WorkUnitGridRow> {
  onEditTask: () => void
  showEditLink?: boolean
}

const WorklistLinks: FC<WorklistLinksProps> = props => {
  // Read once so each branch below carries the narrowed value, not a boolean that says one exists.
  const { elationUrl, patientId } = props.row
  const caseUrl = props.row.links?.caseUrl
  // Patient detail links are shown unless we already link to the specific Case.
  const showPatientLink = !caseUrl && patientId

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', color: 'navy.500' }}>
      {elationUrl ? (
        <Tooltip title="Open in Elation">
          <IconButton
            edge="end"
            component="a"
            href={elationUrl}
            target="_blank"
            rel="noopener noreferrer"
            color="inherit"
          >
            <Box
              component="img"
              src={elationSVG}
              alt="Open in Elation"
              sx={{ width: '2.4rem', maxHeight: '2.4rem' }}
            />
          </IconButton>
        </Tooltip>
      ) : null}
      {showPatientLink ? (
        <Tooltip title="Open Patient">
          <IconButton edge="end" component={Link} to={`/patients/${patientId}`} color="inherit">
            <Face />
          </IconButton>
        </Tooltip>
      ) : null}
      {caseUrl ? (
        <Tooltip title="Open Case">
          <IconButton edge="end" component={Link} to={caseUrl} color="inherit">
            <Face />
          </IconButton>
        </Tooltip>
      ) : null}
      {!(props.showEditLink === false) && (
        <Tooltip title="Edit Task">
          <IconButton edge="end" onClick={props.onEditTask} color="inherit">
            <Edit titleAccess="Edit Task" />
          </IconButton>
        </Tooltip>
      )}
    </Box>
  )
}

export default WorklistLinks
